/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { setWaitingWorker } from './store/swUpdateStore'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      // Check if there was already a waiting worker from a previous update
      navigator.serviceWorker.getRegistration().then(reg => {
        if (reg?.waiting && navigator.serviceWorker.controller) {
          setWaitingWorker(reg.waiting)
        }
      }).catch(() => {/* ignore */})
    },
    registered () { /* noop */ },
    cached () { /* noop */ },
    updatefound () { /* noop */ },
    updated (registration) {
      if (registration.waiting) {
        setWaitingWorker(registration.waiting)
      }
    },
    offline () { /* noop */ },
    error (error) {
      console.error('Service worker error:', error)
    }
  })
}
